import moment from "moment";
class groupSchedule {
  constructor(
    group,
    schedule,
    from,
    to,
    groupId,
    scheduleId) {
  
    this.group = group;
    this.schedule=schedule
    this.from = moment(from).utc().format("DD-MM-YYYY") 
    this.to = to== null ? " " : moment(to).utc().format("DD-MM-YYYY") 
    this.groupId=groupId
    this.scheduleId = scheduleId;
}
  static fromJson({
  grupo,
  horario,
  desde,
  hasta,
  grupoId,
  horarioId
}) {
    return new groupSchedule(
        grupo,
        horario,
        desde,
        hasta,
        grupoId,
        horarioId);
  }
}
export default groupSchedule;
